var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.summaries),function(sItem){return _c('span',{key:sItem.text,staticClass:"summaryItem"},[_c('v-icon',[_vm._v(_vm._s(sItem.icon))]),_vm._v(_vm._s(sItem.text)+" ")],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }